<template>
    <div class="login-container">
        <nuxt-link :to="localePath('/')">
            <div class="logo-img"></div>
        </nuxt-link>

        <div class="main-wrapper">
            <div class="main-img"></div>
            <h1>{{ $t('activate-account') }}</h1>
            <nuxt-link :to="localePath('/login')" class="login-btn">{{ $t('continue') }}</nuxt-link>
        </div>
    </div>
</template>

<script>

export default {
    name: 'RegSuccess',
    head: {
        title: 'Registration success | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        bodyAttrs: {
            class: 'page-reg-success'
        }
    },
    props: {
        navigation: {
            type: Object
        }
    },
    methods: {

    }
}
</script>

<style scoped>
.login-container {
    text-align: center;
    padding: 0 calc(3 * var(--gutter)) calc(4 * var(--gutter));
    align-items: center;
    display: flex;
    flex-direction: column;
}

.logo-img {
    background: url('../assets/v_dark.svg') no-repeat center 50px;
    background-size: contain;
    width: 300px;
    height: 180px;
    margin: 0 auto;
}
.main-wrapper {
    width: 100%;
    height: 284px;
    max-width: 560px;
    padding: 24px 40px;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    display: flex;
    border-radius: 8px;
    background: #F4F4F4;
    margin-top: 64px;
}
.main-img {
    width: 120px;
    height: 120px;
    background: url('../assets/ok.gif') no-repeat center;
    background-size: contain;
}
.main-wrapper h1 {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: normal;
    text-align: center;
    color: black;
}
.login-btn {
    border-radius: 8px;
    background: #004F7F;
    padding: 8px 16px;
    font-family: 'Montserrat', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    color: white;
    text-decoration: none;
}

@media (max-width: 767px) {
    .login-container {
        padding: 16px;
    }
}
</style>

<style>
.page-reg-success .header-toolbar-not-logged,
.page-reg-success .main-footer {
    display: none;
}
</style>
